// PageLayout.tsx
import React from "react";
import { Box } from "@mui/material";

export const PageLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
<Box
  component="main"
  sx={{
    display: "flex",
    flexDirection: "column",
    height: "calc(100vh - 64px)",
    width: "95vw",
    mx: "auto",
    pt: 2,
  }}
>
  {children}
</Box>
);
